// @flow
import _ from 'lodash'
import moment from 'moment'

import CartModifier from '../entities/menu/CartModifier'

import APIEndpoints from '../constants/APIEndpoints'
import ApiError from '../entities/ApiError'

import ApiManager from './ApiManager'

class ApiCartModifier {

  static getCartModifiers(restaurantId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.CART_MODIFIERS.replace('{restaurantId}', restaurantId)

    const requestOptions = {
      endpoint,
      success: (json: Object) => {
        console.log('[GET CART MODIFIERS] SUCCESS: ', json)

        let cartModifiers = json.map((data) => {
          let cartModifier: CartModifier = new CartModifier()
          cartModifier.fromJson(data)
          return cartModifier;
        })

        success(cartModifiers)
      },
      failure: (apiError: ApiError) => {
        console.log('[GET CART MODIFIERS] FAILURE: ', apiError)
        failure(apiError)
      }
    }

    ApiManager.get(requestOptions)
  }

  static getCartModifier(restaurantId: string, cartModifierId: string,
    success: Function, failure: Function) {
    const endpoint = APIEndpoints.CART_MODIFIER.replace('{restaurantId}', restaurantId).replace('{cartModifierId}', cartModifierId)

    const requestOptions = {
      endpoint,
      success: (json: Object) => {
        console.log('[GET CART MODIFIER] SUCCESS: ', json)

        let cartModifier: CartModifier = new CartModifier()
        cartModifier.fromJson(json)

        success(cartModifier)
      },
      failure: (apiError: ApiError) => {
        console.log('[GET CART MODIFIER] FAILURE: ', apiError)
        failure(apiError)
      }
    }

    ApiManager.get(requestOptions)
  }


  static postCartModifier(restaurantId: string, data: CartModifier, success: Function, failure: Function) {
    let endpoint = APIEndpoints.CART_MODIFIERS.replace('{restaurantId}', restaurantId)

    const requestOptions = {
      endpoint,
      data,
      success: (json: Object) => {
        console.log('[POST CART MODIFIERS] SUCCESS: ', json)

        const cartModifier: CartModifier = new CartModifier()
        cartModifier.fromJson(json)

        success(cartModifier)
      },
      failure: (apiError: ApiError) => {
        console.log('[POST CART MODIFIERS] FAILURE: ', apiError)
        failure(apiError)
      }
    }

    ApiManager.post(requestOptions)
  }

  static putCartModifier(restaurantId: string, data: CartModifier, success: Function, failure: Function) {
    let endpoint = APIEndpoints.CART_MODIFIER.replace('{restaurantId}', restaurantId).replace('{cartModifierId}', data.id)

    const requestOptions = {
      endpoint,
      data,
      success: (json: Object) => {
        console.log('[PUT CART MODIFIERS] SUCCESS: ', json)

        const cartModifier: CartModifier = new CartModifier()
        cartModifier.fromJson(json)

        success(cartModifier)
      },
      failure: (apiError: ApiError) => {
        console.log('[PUT CART MODIFIERS] FAILURE: ', apiError)
        failure(apiError)
      }
    }

    ApiManager.put(requestOptions)
  }

  static putCartModifiersPriorities(restaurantId: string, ids: Array<string>, success: Function,
    failure: Function) {

    let endpoint = APIEndpoints.CART_MODIFIERS_PRIORITIES.replace('{restaurantId}', restaurantId)

    const requestOptions = {
      endpoint,
      data: ids,
      success: (json: Object) => {
        console.log('[PUT CART MODIFIERS PRIORITIES] SUCCESS: ', json)

        let cartModifiers = json.map((data) => {
          let cartModifier: CartModifier = new CartModifier()
          cartModifier.fromJson(data)

          return cartModifier;
        })

        success(cartModifiers)
      },
      failure: (apiError: ApiError) => {
        console.log('[PUT CART MODIFIERS PRIORITIES] FAILURE: ', apiError)
        failure(apiError)
      }
    }

    ApiManager.put(requestOptions)
  }
}

export default ApiCartModifier



// WEBPACK FOOTER //
// ./sdk/scripts/api/ApiCartModifier.js